import { IcmsExemptionReason } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';

export const icmsExemptionReasonOptions = [
  {
    value: IcmsExemptionReason.TAXI,
    label: '1 - Táxi',
  },
  {
    value: IcmsExemptionReason.PRODUCER,
    label: '3 - Uso na agropecuária',
  },
  {
    value: IcmsExemptionReason.FLEET_RENTAL,
    label: '4 - Frotista/Locadora',
  },
  {
    value: IcmsExemptionReason.DIPLOMATIC_CONSULAR,
    label: '5 - Diplomático/Consular',
  },
  {
    value: IcmsExemptionReason.AMAZON_MOTORCYCLES,
    label:
      '6 - Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio (Resolução 714/88 e 790/94 – CONTRAN e suas alterações)',
  },
  {
    value: IcmsExemptionReason.SUFRAMA,
    label: '7 - SUFRAMA',
  },
  {
    value: IcmsExemptionReason.SALE_TO_PUBLIC_AGENCY,
    label: '8 - Venda a Órgão Público',
  },
  {
    value: IcmsExemptionReason.OTHERS,
    label: '9 - Outros. (NT 2011/004)',
  },
  {
    value: IcmsExemptionReason.DISABLED_DRIVER,
    label: '10 - Deficiente Condutor (Convênio ICMS 38/12)',
  },
  {
    value: IcmsExemptionReason.DISABLED_NON_DRIVER,
    label: '11 - Deficiente Não Condutor (Convênio ICMS 8/12)',
  },
  {
    value: IcmsExemptionReason.OLYMPICS_2016,
    label: '16 - Olimpíadas Rio 2016 (NT 2015.002)',
  },
  {
    value: IcmsExemptionReason.REQUESTED_BY_TAX_AUTHORITY,
    label: '90 - Solicitado pelo Fisco (NT2016.002)',
  },
];
